import SearchResultItemDetails from './SearchResultItemDetails'

export default SearchResultItemDetails
